import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RoutingUrls } from '@cpak/enums';
import { CustomMessageService } from '@cpak/main-features-lib/services';
import { TranslocoService } from '@ngneat/transloco';

enum ErrorStatus {
  Forbidden = 403,
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private customMessageService: CustomMessageService,
    private translocoService: TranslocoService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<never>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 0 && error.error instanceof ProgressEvent) {
          const message = this.translocoService.translate('generalConnectionErrorMessage');
          this.customMessageService.showErrorMessageLostConnection(message, 'long-toast-message');
        }
        if (error.status === ErrorStatus.Forbidden) {
          this.router.navigate([`/${RoutingUrls.Forbidden}`]);
        }
        const err = {
          error,
          req,
        };
        return throwError(() => err);
      })
    );
  }
}
